import clsx from 'clsx';

import styles from '../OverlayBorder.module.css';

type BorderProps = {
  show: boolean;
  className?: string;
};
const Border = ({ className, show }: BorderProps) => <div className={clsx(className, show && styles.borderShow)} />;

export const BorderLeft = ({ show }: BorderProps) => (
  <Border className={clsx(styles.border, styles.borderLeft)} show={show} />
);
export const BorderRight = ({ show }: BorderProps) => (
  <Border className={clsx(styles.border, styles.borderRight)} show={show} />
);

type BorderTopBottomProps = Pick<BorderProps, 'show'> & {
  size: '' | 'big' | 'small' | 'none';
};

export const BorderTop = ({ show, size }: BorderTopBottomProps) => (
  <Border
    className={clsx(styles.border, styles.borderTop, {
      'u-padding-top-xxl': size === 'big',
      'u-padding-top-xl': size === '',
      'u-padding-top-sm': size === 'small',
      'u-padding-top-none': size === 'none',
    })}
    show={show}
  />
);

export const BorderBottom = ({ show, size }: BorderTopBottomProps) => (
  <Border
    className={clsx(styles.border, styles.borderBottom, {
      'u-padding-bottom-xxl': size === 'big',
      'u-padding-bottom-xl': size === '',
      'u-padding-bottom-sm': size === 'small',
      'u-padding-bottom-none': size === 'none',
    })}
    show={show}
  />
);
